<div>
    <div
        class="flex"
        [ngClass]="{
            'gap-40': !small(),
            'gap-20': small(),
        }"
    >
        @for (option of optionsMapped(); track option; let i = $index) {
            @if (option.visible) {
                <button
                    class="font-headline text-accent z-[9] cursor-pointer border-b-4 text-left leading-27 transition-colors duration-300 ease-in-out"
                    [ngClass]="{
                        'border-accent font-medium': control().value === options()[i].value,
                        'border-transparent': control().value !== options()[i].value,
                        'text-18': !small(),
                        'text-14': small(),
                    }"
                    (click)="tabChange(i)"
                    type="button"
                >
                    {{ option.label }}
                </button>
            }
        }
    </div>
    <div>
        <div class="bg-grey-300 h-1 w-full"></div>
        <div [ngClass]="{ 'overflow-hidden': disableOverflow() }">
            <div class="relative flex transition-all duration-500 ease-in-out" [style]="styleTabContainer()">
                @for (option of optionsMapped(); track option; let i = $index) {
                    @if (option.template) {
                        <div
                            class="transition-opacity duration-[750ms] focus:outline-none"
                            #tabs
                            [ngClass]="{
                                grow: !dynamicHeight(),
                                'h-auto': dynamicHeight(),
                                'max-h-0 opacity-0': control().value !== options()[i].value,
                                'opacity-100': control().value === options()[i].value,
                            }"
                            [style]="styleTabContent()"
                            [attr.inert]="control().value !== options()[i].value ? '' : null"
                            [attr.aria-hidden]="control().value !== options()[i].value ? 'true' : null"
                            tabindex="-1"
                        >
                            <ng-template [cdkPortalOutlet]="option.template" />
                        </div>
                    }
                }
            </div>
        </div>
    </div>
</div>
